import * as React from 'react';

import styled from 'styled-components';
import { JRCFileProps } from './types';

export const CSSFolder = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CSSFolderTop = styled.div`
    display: flex;
    flex-direction: row;
`;

export const CSSFolderTopLeft = styled.div<{ color: string; size: number }>`
    width: ${(props) => props.size * 10}px;
    border-top-left-radius: 2px;
    height: ${(props) => props.size * 4}px;
    opacity: 0.4;
    background-color: ${(props) => props.color};
`;

export const CSSFolderTopRight = styled.div<{ color: string; size: number }>`
    border-style: solid;
    border-top-width: ${(props) => props.size * 4}px;
    border-right-width: 0px;
    border-bottom-width: 0px;
    border-left-width: ${(props) => props.size * 4}px;
    opacity: 0.4;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: ${(props) => props.color};
`;

export const CSSFolderContent = styled.div<{ color: string; size: number }>`
    width: ${(props) => props.size * 20}px;
    height: ${(props) => props.size * 14}px;
    border-radius: 2px;
    border-top-left-radius: 0px;
    background-color: ${(props) => props.color};
`;

export const JRCFileFolder = ({ color = '#392994', size = 1 }: JRCFileProps) => {
    return (
        <CSSFolder>
            <CSSFolderTop>
                <CSSFolderTopLeft color={color} size={size} />
                <CSSFolderTopRight color={color} size={size} />
            </CSSFolderTop>
            <CSSFolderContent color={color} size={size} />
        </CSSFolder>
    );
};
